import React from "react";
import styled from "styled-components";
import GlobalStyles from "./GlobalStyles";

import { device, colors, fonts, fontWeights } from "./StyleVariables";
import bg from "./bg.jpg";
import bgLg from "./bg-lg.jpg";

const PageWrap = styled.div`
  align-content: space-between;
  background-color: ${colors.background};
  background-image: url(${bg});
  background-position: top center;
  background-repeat: no-repeat;
  background-size: 768px auto;
  color: ${colors.white};
  display: flex;
  flex-direction: column;
  font-family: ${fonts.museo};
  font-weight: ${fontWeights.medium};
  min-height: 100vh;
  padding: 2.5rem 5%;

  @media ${device.sm} {
    background-position: top;
    background-image: url(${bgLg});
    background-repeat: no-repeat;
    background-size: 1350px auto;
    padding: 4.625rem 5% 2.875rem;
  }

  @media ${device.md} {
    padding: 6.25rem 5% 2.5rem;
  }

  @media ${device.lg} {
    background-size: cover;
  }
`;

const Page = ({ children }) => (
  <PageWrap>
    <GlobalStyles />
    {children}
  </PageWrap>
);

export default Page;
